module.exports = __webpack_public_path__ + "img/黄色叉子1.a954c4db.png";